/**
 * Card primitives — shadcn-style, utilitarian (D-03).
 */
import * as React from 'react';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
}

export function Card({ className = '', children, ...props }: CardProps) {
  return (
    <div
      {...props}
      className={[
        'bg-bg-card border border-border rounded-lg',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </div>
  );
}

export function CardHeader({ className = '', children, ...props }: CardProps) {
  return (
    <div
      {...props}
      className={['px-4 py-3 border-b border-border', className]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </div>
  );
}

export function CardTitle({ className = '', children, ...props }: CardProps) {
  return (
    <h3
      {...(props as React.HTMLAttributes<HTMLHeadingElement>)}
      className={['text-sm font-semibold text-text', className]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </h3>
  );
}

export function CardContent({ className = '', children, ...props }: CardProps) {
  return (
    <div
      {...props}
      className={['px-4 py-3', className].filter(Boolean).join(' ')}
    >
      {children}
    </div>
  );
}

export function CardFooter({ className = '', children, ...props }: CardProps) {
  return (
    <div
      {...props}
      className={[
        'px-4 py-3 border-t border-border flex items-center gap-2',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </div>
  );
}
